import { render, staticRenderFns } from "./shoppingAction.vue?vue&type=template&id=70a6747a&"
import script from "./shoppingAction.vue?vue&type=script&lang=js&"
export * from "./shoppingAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports